(function () {
  document.addEventListener(
    "click",
    function (event) {
      if (typeof window.ghiaTrack !== "function") return;

      var target = event.target;
      if (!target || typeof target.closest !== "function") return;

      var link = target.closest('a[href*="/products/"]');
      if (!link) return;

      var container = link.closest("[data-item-list]");
      if (!container) return;

      var href = link.getAttribute("href") || "";
      var handle = href.split("/products/")[1] || "";
      handle = handle.split("?")[0].split("#")[0].split("/")[0];

      window.ghiaTrack("product_card_click", {
        item_list_name: container.getAttribute("data-item-list"),
        product_handle: handle,
      });
    },
    true
  );
})();
